import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { finalize, tap } from 'rxjs/operators';
import { Validator } from './validator';
import { Router } from '@angular/router';
import { MessageService } from './message.service';
import { ApplicationMode } from './application.service';
import { EMPTY } from 'rxjs';
import * as moment from 'moment';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable({ providedIn: 'root' })
export class ServiceInterceptor implements HttpInterceptor {

  public ApplicationMode: ApplicationMode;
  
  constructor(
    private oauthService: OAuthService,    
    private router: Router,
    private validator: Validator,
    public messageService: MessageService
  ) {
    
  }

  requests = [];

  intercept(request: HttpRequest<any>, next: HttpHandler) {

    let service = this;

    var newUrl = request.url.replace(/\/\//g, '/').replace(/http:\//g, 'http://').replace(/https:\//g, 'https://');
    var authReq = request.clone({
      url: newUrl
    });

    if (request.url.indexOf('localhost:3') < 0 && request.url.indexOf('localhost:4201') < 0 && sessionStorage.getItem("avbobJWT")) {
      var jwt = sessionStorage.getItem("avbobJWT") || '';
      authReq = request.clone({
        url: newUrl,
        headers: request.headers.set('Authorization', jwt)
      });
    }

    if (request.url.indexOf('localhost:3') < 0 && request.url.indexOf('localhost:4201') < 0 && service.oauthService.getAccessToken()) {
      authReq = request.clone({
        url: newUrl,
        headers: request.headers.set('Authorization', "Bearer " + service.oauthService.getAccessToken())
      });
    }

    let newRequest = { url: request.url, body: request.body, timestamp: moment() };
    let existingRequest = service.requests.find(i => i.url == request.url);

    if (existingRequest && existingRequest.body == newRequest.body) {
      var duration = moment.duration(existingRequest.timestamp.diff(newRequest.timestamp));
      var lapse = duration.asMilliseconds();
      if (lapse < 2000) {
        console.log("Request to " + request.url + " has already been fired in the last 2 seconds. Please wait 2000 millisconds before sending again");
        return EMPTY;
      }
    }

    service.requests.push(newRequest);

    if (service.requests.length >= 1) {
      service.validator.Clear();
      window["isBusy"] = true;
    }

    return next.handle(authReq)
      .pipe(
        tap(
        event => {
            if (event instanceof HttpResponse) {
              if (event.body && !event.body.Result && !event.body.Ignore && event.body.Message) {
                if (event.body.ValidationErrors && event.body.ValidationErrors.length) {
                  event.body.ValidationErrors.forEach((item) => {
                    service.validator.Add(item);
                  });
                }
                else {
                  if (service.messageService.showErrorDetail || !service.messageService.errorMessage) {
                    service.messageService.showError(event.body.Message + service.messageService.errorMessage);
                  }
                  else {
                    service.messageService.showError(service.messageService.errorMessage);
                  }
                }
              }
            }
          } , response => {
          if (response.status != 200) {
            if (response.status == 401) {
              sessionStorage.removeItem("avbobJWT");
              if (service.messageService.applicationMode == ApplicationMode.SelfService) {
                service.router.navigate(['/']);
                }
              else {
                if (service.messageService.refresh) {
                  window.location.reload();
                }
                else {
                  service.router.navigate(['/account/login']);
                }
              }
            }
            else {
                let message = response.message || 'A problem was encountered accessing an external service. Please try again later or contact support';
              if (response.message && !response.Ignore && !response.ignore) {

                service.messageService.logError(newRequest, response);

                if (service.messageService.errorMessage) {
                  if (service.messageService.showErrorDetail) {
                    service.messageService.showError(message + service.messageService.errorMessage);
                  }
                  else {
                    service.messageService.showError(service.messageService.errorMessage);
                  }
                }
                else {
                  let msg = response.error?.Message;
                  if (msg) {
                    service.messageService.showError(msg);
                  }
                  else if (response.error && typeof response.error == "string") {
                    service.messageService.showError(response.error);
                  }
                }
              }
            }
          }
        }),
        finalize(() => {
          let r = service.requests.find(i => i.url == request.url && i.body == request.body);
          let index = service.requests.indexOf(r);
          service.requests.splice(index, 1);
          if (service.requests.length <= 0) {
            window["isBusy"] = false;
          }
        })
      );
   
  }
}

